module.exports = __webpack_public_path__ + "static/img/pollutant_degree_spatial-bing-1.dd68723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cause_analyse/pollutant_degree_spatial-bing-1.png
// module id = XQUI
// module chunks = 82